export default __webpack_public_path__ + "static/media/ovary4.85150515.jpg";